module.exports = __webpack_public_path__ + "static/media/71.2d9d1fd0.jpg";